import { hasOgsBundleMarker } from './ogsContentSelect.js'

// Canonical "does this character have a rig GLB?" test — a missing rig is a
// legitimate authoring state (create empty, upload rig / OGS assets later), not an error.
// App.jsx gates the AvatarModel mount on this; splat/stream characters never need it.
export function checkForRig(character) {
  const rigPath = character?.rigPath
  return typeof rigPath === 'string' && rigPath.trim().length > 0
}

// Missing = neither a rig GLB nor an /ogs bundle (rows from GET /api/characters/{id}/ogs).
export function checkMissingRig(character, ogsRows) {
  if (!character) return false
  return !checkForRig(character) && !hasOgsBundleMarker(ogsRows)
}
